import React from "react";

import { Tooltip } from "antd";
import styled from "styled-components";

import { FlexItem, NodeTitle } from "../../../shared/nodes/StyledNodePartials";

export interface IRootNode {
  title: string;
  tooltip?: string;
}

export function RootFolder({ title, tooltip }: IRootNode) {
  const content = (
    <NodeTitle>
      <FlexItem>
        <label>{title}</label>
      </FlexItem>
    </NodeTitle>
  );

  if (tooltip) {
    return (
      <NodeWrapper $isDisabled={true}>
        <CheckboxTooltipWrapper>
          <Tooltip title={tooltip} placement="top">
            <CheckboxOverlay />
          </Tooltip>
        </CheckboxTooltipWrapper>
        {content}
      </NodeWrapper>
    );
  }

  return content;
}

// Wrapper to position the checkbox tooltip - doesn't affect grid layout
const NodeWrapper = styled.div<{ $isDisabled?: boolean }>`
  position: relative;

  /* Override Ant Design's checkbox background when disabled */
  ${(props) =>
    props.$isDisabled &&
    `
    .ant-tree-checkbox-disabled .ant-tree-checkbox-inner {
      background-color: transparent !important;
      border-color: #d9d9d9 !important;
    }
  `}
`;

// Positioned over the checkbox area to capture hover events
const CheckboxTooltipWrapper = styled.div`
  position: absolute;
  left: -27px; /* Position to cover the checkbox */
  top: 0;
  width: 24px;
  height: 24px;
  z-index: 1;
  pointer-events: auto;
`;

// Invisible overlay that triggers the tooltip
const CheckboxOverlay = styled.div`
  width: 100%;
  height: 100%;
  cursor: not-allowed;
`;
